import urljoin from 'url-join';
import AdminRequest from './AdminRequest';

/**
 * Provides a set of CRUD operations around an API base path.
 */
export default class CRUD extends AdminRequest {
	constructor(uri, idProperty = 'id', options = {}) {
		super(uri, options);
		this.idProperty = idProperty;
	}

	create(item) {
		return this._op('post', this.uri, item);
	}

	getAll() {
		return this._op('get', this.uri);
	}

	get(id) {
		return this._op('get', urljoin(this.uri, id));
	}

	update(item) {
		return this._op('put', urljoin(this.uri, item[this.idProperty]), item);
	}

	delete(id) {
		return this._op('delete', urljoin(this.uri, id));
	}
}

